import { SxProps } from '@mui/system'
import React from 'react'
import { StyledMasonryTile } from '../../styles/MasonryStyles'

type MasonryTileProps = {
  onClick?: () => void
  disabled?: boolean
  sx?: SxProps
}

const MasonryTile = React.forwardRef<HTMLDivElement, React.PropsWithChildren<MasonryTileProps>>(
  ({ children, onClick, disabled = false, sx }, ref) => {
    const handleClick = () => {
      if (onClick && !disabled) onClick()
    }

    const isClickable = !!onClick && !disabled

    const elevation = disabled ? 1 : 2

    const baseSx = {
      px: { xs: 2, md: 3 },
      ...sx,
    }

    const clickableSx = {
      color: 'text.base',
      transition: 'all 150ms ease-in-out',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'background.elevation2',
      },
      ':focus': {
        backgroundColor: 'background.elevation2',
      },
    }

    const finalSx = isClickable
      ? { ...baseSx, ...clickableSx }
      : { ...baseSx, color: disabled ? 'text.disabled' : 'text.base' }

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (!isClickable) return
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleClick()
      }
    }

    return (
      <StyledMasonryTile
        ref={ref}
        elevation={elevation}
        onClick={handleClick}
        sx={finalSx}
        tabIndex={isClickable ? 0 : undefined}
        onKeyDown={isClickable ? handleOnKeyDown : undefined}
      >
        {children}
      </StyledMasonryTile>
    )
  }
)

export default MasonryTile
